module.exports = __webpack_public_path__ + "static/media/image-992.67ea0107.jpg";